import { res, searchCnt } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
export default {
    async search(searchData: FormData): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/search", searchData, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getBalance(): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/search/balance", null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getList(
        page: number,
        size: number,
        searchType: number,
        startDate: string,
        endDate: string,
        type: string,
        searchContent: string,
        sns: any,
    ): Promise<res> {
        const res = {} as res;

        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/search/info",
                {
                    page,
                    size,
                    searchType,
                    startDate,
                    endDate,
                    type: type,
                    searchContent,
                    sns: sns,
                },
                { withCredentials: false },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getSearchInfo(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/search/info/condition/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async detailInfo(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/search/info/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getResultList(idx: number, size: number, page: number, filterList: any): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/search/result/" + idx,
                {
                    page,
                    size,
                    searchType: filterList.searchType,
                    sns: filterList.sns,
                    type: filterList.type,
                    resultType: filterList.resultType,
                    resultDetailType: filterList.resultDetailType,
                    nation: filterList.nation,
                    searchContent: filterList.searchContent,
                    isMonitoring: filterList.isMonitoring,
                },
                { withCredentials: false },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getResultDetail(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/search/result/detail/" + idx, null, { withCredentials: false });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async deleteList(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/search/info/remove/" + idx, null, { withCredentials: false });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async deleteLists(idxList: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/search/info/remove/list", { idxList }, { withCredentials: false });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async saveResultType(idx: number, type: number, detailType: number, detailContent: string): Promise<res> {
        const res = {} as res;
        if (detailType !== 6) detailContent = "";
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/search/result/type/update",
                {
                    idx,
                    type,
                    detailType,
                    detailContent,
                },
                { withCredentials: false },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async isMonitoring(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/search/result/monitoring/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async multiMonitoring(idxList: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/search/result/multi/monitoring",
                {
                    idxList,
                },
                {
                    withCredentials: false,
                },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async multiDelete(idxList: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/search/result/remove",
                {
                    idxList,
                },
                {
                    withCredentials: false,
                },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getSearchCnt(param: { startDate: string; endDate: string }): Promise<res<searchCnt>> {
        const res = {} as res<searchCnt>;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/search/info/status/cnt", param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
};
